import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { volumes } from '../../data/volumes';
export function Volumes() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-345" data-mp="2wzyrogkxb6jz">
      <div className="mx-auto max-w-4xl" data-id="element-346" data-mp="2szyet0dh33f1">
        <SectionHeading kicker="6 premium volumes" title={<>
              What's inside <em className="text-cta" data-id="element-348" data-mp="2o26epj2ocazr">Reflexology 21-Day Practice Method™</em>?
            </>} data-id="element-347" data-mp="2syws1yn3gshh" />

        <ol className="mt-10 space-y-5" data-id="element-349" data-mp="2j7sbiuhrszkj">
          {volumes.map(v => <li key={v.number} className="overflow-hidden rounded-3xl bg-paper shadow-[0_8px_30px_-18px_rgba(10,51,40,0.35)]" data-id="element-350" data-mp="2ebbok3mb4r91">
              <div className="flex items-center gap-4 px-5 py-4 sm:px-7" style={{
            backgroundColor: v.accent
          }} data-id="element-351" data-mp="299meoratmjmj">
                <span className="font-serif text-4xl font-extrabold text-forest" data-id="element-352" data-mp="20b0w4w5cn4lr">{v.number}</span>
                <div data-id="element-353" data-mp="335me38veahlk">
                  <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-forest/80" data-id="element-354" data-mp="33548vmqr8t1i">Volume {v.number}</p>
                  <h3 className="font-serif text-xl font-bold leading-tight text-forest sm:text-2xl" data-id="element-355" data-mp="37xe5flmdkrcr">{v.title}</h3>
                </div>
              </div>
              <div className="px-5 py-5 sm:px-7 sm:py-6" data-id="element-356" data-mp="2y6j91off0bdl">
                <p className="text-base leading-relaxed text-ink/85" data-id="element-357" data-mp="2y72ql415kxr3">{v.intro}</p>
                <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-cta" data-id="element-358" data-mp="3lx6wji1td9l9">{v.listLabel}</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-359" data-mp="3qtxb20xyzx4k">
                  {v.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-ink" data-id="element-360" data-mp="3cv5zomahspk4">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-361" data-mp="3hsz5vfbspjke" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 border-t border-sand pt-4 font-serif text-lg font-semibold italic text-forest" data-id="element-362" data-mp="26gog7hscm3k6">{v.closing}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10" data-id="element-363" data-mp="70ljv3os417g">
          <CTAButton label="Yes! I want all 6 volumes today" note="One-time payment of $27 · Instant digital access" data-id="element-364" data-mp="29c02jpwvs3h" />
        </div>
      </div>
    </section>;
}